import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { success } from '~/Redux/Modules/Notifications';

import Modal from '~/Containers/Global/Modal/Modal';
import { MY_ACCOUNT_MODAL } from '~/Config/Modals';
import { handleGet } from '~/Redux/Modules/Account';

import UserSettings from '~/Containers/Pages/Account/UserSettings/UserSettings';
import PaymentsAndBilling from '~/Components/Pages/Account/PaymentsAndBilling/PaymentsAndBilling';
import Support from '~/Components/Pages/Account/Support/Support';
import CancellationReport from '~/Components/Pages/Account/CancellationReport';
import CriticReport from '~/Components/Pages/Account/CriticReport';
import Referrals from '~/Components/Pages/Account/Referrals';
import StripePermittedView from '~/Components/Global/StripePermittedView';
import ConsentRequiredView, { CONSENT_TYPE_COOKIES } from '~/Components/Global/ConsentRequiredView';

import UnlockCode from './UnlockCode';
import TrackingStatus from './TrackingStatus';
import './MyAccount.scss';

class MyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportOpen: false,
      referralsOpen: false,
      cancellationOpen: false,
      cancellationProcessing: false,
    };
  }

  renderReport = () => {
    if (!this.state.reportOpen) return;
    return <CriticReport key="c" closeReport={() => this.setState({ reportOpen: false })} />;
  };

  renderReferrals = () => {
    if (!this.state.referralsOpen) return;
    return <Referrals key="d" closeReferrals={() => this.setState({ referralsOpen: false })} />;
  };

  renderCancellation = () => {
    if (!this.state.cancellationOpen) return;
    return (
      <CancellationReport
        key="d"
        closeReport={() => false}
        close={() => this.setState({ cancellationOpen: false })}
        openReport={() => this.setState({ reportOpen: true, cancellationOpen: false })}
      />
    );
  };

  renderMain = () => {
    if (this.state.reportOpen || this.state.referralsOpen || this.state.cancellationOpen) return;
    return (
      <>
        <div className="row" key="a">
          <div className="col-sm-6" key="aa">
            <UserSettings />
          </div>
          <div className="col-sm-6" key="ab">
            <PaymentsAndBilling
              openReferrals={() => this.setState({ referralsOpen: true })}
              openCancellation={this.handleOpenCancellation}
            />
          </div>
        </div>
        <ConsentRequiredView
          consentType={CONSENT_TYPE_COOKIES}
          disabledView={
            <>
              <div className="row" key="b" style={{ paddingTop: 25 }}>
                <div className="col-sm-6">
                  <Referrals key="d" />
                </div>
                <div className="col-sm-6">
                  <Support openReport={() => this.setState({ reportOpen: true })} />
                  <div className="padding-top">
                    <UnlockCode />
                  </div>
                </div>
              </div>
            </>
          }
        >
          <div className="row" key="b" style={{ paddingTop: 25 }}>
            <div className="col-sm-6">
              <TrackingStatus />
            </div>
            <div className="col-sm-6">
              <Support openReport={() => this.setState({ reportOpen: true })} />
            </div>
          </div>
          <div className="row" key="b" style={{ paddingTop: 25 }}>
            <div className="col-sm-6">
              <Referrals key="d" />
            </div>
            <div className="col-sm-6">
              <StripePermittedView>
                <UnlockCode />
              </StripePermittedView>
            </div>
          </div>
        </ConsentRequiredView>
      </>
    );
  };

  handleOpenCancellation = () => {
    if (this.state.cancellationProcessing) return;

    this.setState({ cancellationProcessing: true });

    const userSubscriptions = this.props.user?.subscriptions || [];
    const paddleSubscription = userSubscriptions.find(sub => sub.paddle_subscription_id);

    if (
      paddleSubscription &&
      paddleSubscription.paddle_subscription_id &&
      window.Paddle &&
      window.Paddle.Retain &&
      typeof window.Paddle.Retain.initCancellationFlow === 'function' &&
      typeof window.profitwell === 'function'
    ) {
      window.Paddle.Retain.initCancellationFlow({
        subscriptionId: paddleSubscription.paddle_subscription_id,
      })
        .then(paddleResult => {
          console.log('paddleResult', paddleResult);
          if (
            paddleResult &&
            (paddleResult.status === 'cancelled' || paddleResult.status === 'chose_to_cancel')
          ) {
            this.props.success('Subscription Cancelled');
            this.props.fetchAccount();
          }
          if (paddleResult && paddleResult.status === 'error') {
            this.setState({ cancellationOpen: true });
          }
        })
        .catch(err => {
          console.error('Error in Paddle cancellation flow:', err);
          this.setState({ cancellationOpen: true });
        })
        .finally(() => {
          this.setState({ cancellationProcessing: false });
        });
    } else {
      this.setState({
        cancellationOpen: true,
        cancellationProcessing: false,
      });
    }
  };

  render() {
    const { modalId } = this.props;
    return (
      <Modal overlayClassName="my-account-modal" id={modalId} displayOverlay ariaHideApp={false}>
        <div className="row" key="d">
          <div className="col-xs-12">
            <span className="my-account-header" style={{ fontSize: '2em' }}>
              My Account
            </span>
          </div>
        </div>
        {this.renderMain()}
        {this.renderReport()}
        {this.renderReferrals()}
        {this.renderCancellation()}
      </Modal>
    );
  }
}

MyAccount.propTypes = {
  modalId: propTypes.string,
  user: propTypes.object,
  success: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
};

MyAccount.defaultProps = {
  modalId: MY_ACCOUNT_MODAL,
  user: null,
};

const mapStateToProps = ({ User }) => {
  return {
    user: User.data,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    success: (title, body) => dispatch(success(title, body)),
    fetchAccount: () => dispatch(handleGet()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);
